import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { apiFunctionCall, constructBody } from "./constructBody";
import { errorToastify, successToastify } from "../Toaster";

function DeleteComponent({
  modal_delete,
  tog_delete,
  fetchData,
  deleteId,
  keyName,
  deleteName,
}) {
  const body = constructBody(keyName, deleteId, deleteName);

  const handleDelete = async () => {
    try {
      const response = await apiFunctionCall(keyName, body);
      console.log("RESPONSE AFTER DELETE DATA", response);
      if (response.statusCode === 200) {
        successToastify(`${keyName} Deleted Successfully`);
        fetchData();
        tog_delete();
      } else {
        console.error("Delete Error :", response);
      }
      if (keyName === "ProductTypeWithOutHUID" && response.statusCode === 400) {
        errorToastify(response.data);
      } else if (response.statusCode === 400) {
        errorToastify(response.message);
      }

      if (response.statusCode === 409) {
        errorToastify(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Modal isOpen={modal_delete} toggle={tog_delete} centered>
      <ModalHeader toggle={tog_delete}>
        {keyName === "ProductType"
          ? "Return Confirmation"
          : "Delete Confirmation"}
      </ModalHeader>
      <ModalBody>
        <p>Are you sure you want to delete this {keyName}?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleDelete}>
          {keyName === "ProductType" ? "Return" : "Delete"}
        </Button>
        <Button color="secondary" onClick={tog_delete}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeleteComponent;
